import React, { Component } from "react";
import { connect } from "react-redux";

import Document from "./Steps/document";
import SelectPhone from "./Steps/selectPhone";
import Invoices from "./Steps/invoices";
import SmsValidation from "./Steps/smsValidation";
import Success from "./Steps/success";
import Error from "./Steps/error";

class Multiplos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  handleStep = step => {
    this.setState({ step: step });
  };

  render() {
    const { close } = this.props;
    const step = this.props.step;
    switch (step) {
      case 1: {
        return <Document close={close} />;
      }
      case 2: {
        return <SelectPhone close={close} back />;
      }
      case 3: {
        return <Invoices close={close} back />;
      }
      case 4: {
        return <SmsValidation close={close} back />;
      }
      case 5: {
        return <Success close={close} />;
      }
      case 6: {
        return <Error close={close} />;
      }
    }
  }
}

const mapStateToProps = state => ({
  step: state.multiplosReducer.step
});

export default connect(mapStateToProps)(Multiplos);
